type ToastType = 'success' | 'error' | 'info' | 'warning';

interface Toast {
    id: string;
    open: boolean;
    title: string;
    description: string;
    type: ToastType;
    duration: number;
}

// Single toast state (not array anymore)
const toastState = ref<Toast | null>(null);

export const useToast = () => {
    const showToast = (
        title: string = 'عنوان',
        description:  string = '',
        type: ToastType = 'success',
        duration: number = 2000
    ) => {
        // Close previous toast first, then show new one
        toastState.value = {
            id: crypto.randomUUID(),
            open: true,
            title,
            description,
            type,
            duration
        };
    };

    const closeToast = () => {
        if (toastState.value) {
            toastState.value.open = false;
        }
    };
    const clearToast = () => {
        toastState.value = null;
    };

    return {
        toastState,
        showToast,
        closeToast,
        clearToast
    };
};